import { checkDefined } from '@com-delta-idp/mnx-skymiles-shared';
import { EntryItem, EntryItemAriaLabel } from '@com-delta-omnichannel/aura';
import { Categories, MqdSummary } from '../models/aem/overview.interface';
import {
  CurrentYearDashboardEntity,
  EarnsSummaryResponse
} from '../models/api/earns-summary.interfaces';
import {
  addCardActivity,
  addDefaultAmexCard,
  addDefaultJapanCard,
  addOtherActivity,
  checkCard,
  getDefaultCardWithId
} from './earns-summary-extended.utils';
import { addEntryItem, hasActivity } from './earns-summary.utils';

export const getActivities = (
  aem: MqdSummary,
  activities: EarnsSummaryResponse,
  countryCode: string
): EntryItem[] => {
  let activityValues: EntryItem[] = [];
  const findFirstNode: string[] = [];

  if (aem.categories && activities.currentYearDashboard) {
    const defaultAmexCard = addEntryItem(
      aem,
      activities,
      countryCode,
      'AXS',
      'US',
      'NO-CARD-US'
    );
    const defaultJapanCard = addEntryItem(
      aem,
      activities,
      countryCode,
      'JPN',
      'JP',
      'NO-CARD-JPN'
    );

    activities.currentYearDashboard.forEach((activity, index) => {
      aem.categories.forEach((category) => {
        if (hasActivity(activity, category)) {
          const addedActivity = checkCard(category, activity, index);

          const addAmex = addDefaultAmexCard(
            activity,
            getDefaultCardWithId(
              defaultAmexCard,
              category.code + category.type,
              index
            ),
            'AXS',
            category
          );
          activityValues = [...activityValues, ...addAmex];

          const addJapan = addDefaultJapanCard(
            activity,
            getDefaultCardWithId(
              defaultJapanCard,
              category.code + category.type,
              index
            ),
            'JPN',
            category
          );
          activityValues = [...activityValues, ...addJapan];

          activityValues = [
            ...activityValues,
            ...addCardActivity(activity, addedActivity, 'AXS', category)
          ];

          activityValues = [
            ...activityValues,
            ...addCardActivity(activity, addedActivity, 'JPN', category)
          ];

          activityValues = [
            ...activityValues,
            ...addOtherActivity(activity, addedActivity)
          ];

          category.type
            ? findFirstNode.push(category.type)
            : findFirstNode.push(category.code);
        }
      });
    });
  }
  return activityValues;
};

export const findActivity = (
  activities: EarnsSummaryResponse,
  categoryCode: string
): CurrentYearDashboardEntity[] => {
  const cardActivity: CurrentYearDashboardEntity[] = [];
  activities.currentYearDashboard.forEach((activity) => {
    if (activity.categoryCode === categoryCode && activity.activityCnt === 0) {
      cardActivity.push(activity);
    }
  });
  return cardActivity;
};

export const getTitle = (activity: CurrentYearDashboardEntity): string => {
  return activity && activity.categoryDesc ? activity.categoryDesc : '';
};

export const getSubTitle = (
  activity: CurrentYearDashboardEntity,
  aemCategory: Categories
): string => {
  return activity && activity.cardTypeCode
    ? checkDefined(aemCategory.description)
    : '';
};

export const getActivityId = (aem: Categories, index?: number): string => {
  return aem?.type && aem.code !== aem.type
    ? `${aem.code}_${aem.type}_${index}`
    : `${aem.code}_${index}`;
};

export const getTooltipAriaLabel = (
  tooltip: string | undefined,
  activity: CurrentYearDashboardEntity
): EntryItemAriaLabel => {
  return {
    icon: `${getTitle(activity)} icon`,
    info: tooltip ? `${getTitle(activity)} info` : '' //  info text value should be received from AEM
  };
};
